import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import IdleTimer from 'react-idle-timer'

import Button from '../../../1stlog-ui/src/components/Button'
import Dialog from '../../../1stlog-ui/src/components/Dialog'
import { request } from '../../../1stlog-ui/src/utils'

// timeOutDuration in s
// timeUntilLogout in s

const Timer = (props) => {
  const {
    timeOutDuration = 100 * 60 * 1,
    timeUntilLogout = 900,
    logoutUrl = '/logout',
  } = props
  let refIdleTimer = useRef()

  const [timeout, setTimeout] = useState(timeOutDuration)
  const [remaining, setRemaining] = useState(null)
  const [isIdle, setIsIdle] = useState(false)
  const [lastActive, setLastActive] = useState(null)
  const [elapsed, setElapsed] = useState(null)
  const [showDialog, setDialog] = useState(false)
  const [idleCountdown, setIdleCountdown] = useState(null)
  const [interValId, setIntervalId] = useState()
  const [isLoggedOut, setIsLoggedOut] = useState(false)
  const [showExpiredModal, setShowExpiredModal] = useState(false)

  useEffect(() => {
    setTimeout(timeOutDuration)

    setRemaining(refIdleTimer?.current?.getRemainingTime() || 0)
    setLastActive(refIdleTimer?.current?.getLastActiveTime() || 0)
    setElapsed(refIdleTimer?.current?.getElapsedTime() || 0)

    const timerInterval = setInterval(() => {
      setRemaining(refIdleTimer?.current?.getRemainingTime() || 0)
      setLastActive(refIdleTimer?.current?.getLastActiveTime() || 0)
      setElapsed(refIdleTimer?.current?.getElapsedTime() || 0)
    }, 500)

    return () => {
      clearInterval(timerInterval)
      clearInterval(interValId)
    }
  }, [timeOutDuration])

  const onAction = (e) => {
    setLastActive(refIdleTimer.current.getLastActiveTime())
  }

  const onActive = (e) => {
    clearInterval(interValId)
    // setIsIdle(false)
    setDialog(false)
    refIdleTimer.current.reset()
  }

  const onIdle = (e) => {
    let duration = moment.duration(timeUntilLogout * 1000, 'milliseconds')

    const interval = 500

    const idleInterval = setInterval(() => {
      duration = moment.duration(
        duration.asMilliseconds() - interval,
        'milliseconds',
      )

      if (duration.asMilliseconds() <= 0) {
        request({
          method: 'get',
          url: logoutUrl,
        })
        setIsLoggedOut(true)
        setShowExpiredModal(true)
        clearInterval(idleInterval)
      } else {
        setIdleCountdown(duration.asMilliseconds())
      }
    }, 500)

    setIntervalId(idleInterval)
    setIsIdle(true)
    // setDialog(true)
  }

  if (isLoggedOut) {
    return (
      <Dialog
        show={showExpiredModal}
        onHide={() => setShowExpiredModal(false)}
        size="md"
        title={i18n.t(
          'for_security_reasons_you_have_been_automatically_logged_out_due_to_inactivity',
          'Aus Sicherheitsgründen wurden Sie aufgrund von Inaktivität automatisch abgemeldet.',
        )}
        showCloseIcon={false}
        backdrop="static"
      >
        <div className="d-flex justify-content-end">
          <Button onClick={() => (window.location.href = '/')} primary>
            {i18n.t('log_in_again', 'Erneut Anmelden')}
          </Button>
        </div>
      </Dialog>
    )
  }
  if (timeout === 0 || !timeout) {
    return null
  }
  return (
    <div>
      <IdleTimer
        ref={(ref) => {
          refIdleTimer.current = ref
        }}
        element={document}
        onActive={onActive}
        onIdle={onIdle}
        debounce={250}
        onAction={onAction}
        timeout={timeout * 1000}
      />
      {/* <h1>Timeout: {timeout}ms</h1>
      <h1>Time Remaining: {remaining}</h1>
      <h1>Time Elapsed: {elapsed}</h1>
      <h1>Last Active: {lastActive}</h1>
      <h1>Idle: {isIdle.toString()}</h1>
      <Dialog
        show={showDialog}
        onHide={() => setDialog(false)}
        size="md"
        title={"Inaktiv"}
      >
        {idleCountdown && idleCountdown > 0 && (
          <h3>
            Sie werden in{" "}
            <span className="text-danger">{`${moment(idleCountdown).format(
              "mm:ss"
            )}`}</span>{" "}
            ausgeloggt
          </h3>
        )}
      </Dialog> */}
    </div>
  )
}

export default Timer
